<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>Welcome to GirlBoyShop</h1>
          <p>Pakistan's Ultimate Destination for Trendy Clothes</p>
          <div class="hero-buttons">
            <router-link to="/products?category=men" class="btn btn-primary">Shop Men</router-link>
            <router-link to="/products?category=women" class="btn btn-secondary">Shop Women</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Categories Section -->
    <section class="categories section-padding">
      <div class="container">
        <h2 class="section-title">Shop by Category</h2>
        <div class="categories-grid">
          <div class="category-card">
            <router-link to="/products?category=men">
              <div class="category-image men"></div>
              <h3>Men's Collection</h3>
              <p>Latest styles for men</p>
            </router-link>
          </div>
          <div class="category-card">
            <router-link to="/products?category=women">
              <div class="category-image women"></div>
              <h3>Women's Collection</h3>
              <p>Trendy fashion for women</p>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Featured Products Section -->
    <section class="featured-products section-padding">
      <div class="container">
        <h2 class="section-title">Featured Products</h2>
        <div class="products-grid">
          <product-card
            v-for="product in featuredProducts"
            :key="product.id"
            :product="product"
          ></product-card>
        </div>
        <div class="view-all-button">
          <router-link to="/products" class="btn btn-primary">View All Products</router-link>
        </div>
      </div>
    </section>

    <!-- Why Choose Us Section -->
    <section class="why-choose-us section-padding">
      <div class="container">
        <h2 class="section-title">Why Choose Us</h2>
        <div class="features-grid">
          <div class="feature">
            <i class="fas fa-truck"></i>
            <h3>Fast Delivery</h3>
            <p>Get your orders delivered quickly across Pakistan</p>
          </div>
          <div class="feature">
            <i class="fas fa-shield-alt"></i>
            <h3>Secure Payments</h3>
            <p>Pay securely using JazzCash or EasyPaisa</p>
          </div>
          <div class="feature">
            <i class="fas fa-tshirt"></i>
            <h3>Quality Products</h3>
            <p>We ensure the best quality for all our products</p>
          </div>
          <div class="feature">
            <i class="fas fa-exchange-alt"></i>
            <h3>Easy Returns</h3>
            <p>Hassle-free return policy for your convenience</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductCard from '@/components/products/ProductCard.vue'

/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'Home',
  components: {
    ProductCard
  },
  computed: {
    ...mapGetters(['allProducts']),
    featuredProducts() {
      return this.allProducts.filter(product => product.featured).slice(0, 6)
    }
  }
}
</script>

<style scoped>
.home {
  background-color: #f8f9fa;
}

.section-padding {
  padding: 60px 0;
}

/* Hero Section */
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
              url('https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80');
  background-size: cover;
  background-position: center;
  color: white;
  text-align: center;
  padding: 100px 0;
}

.hero-content {
  max-width: 700px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 42px;
  margin-bottom: 20px;
}

.hero p {
  font-size: 18px;
  margin-bottom: 30px;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

/* Categories Section */
.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.category-card {
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.category-card:hover {
  transform: translateY(-10px);
}

.category-image {
  height: 250px;
  background-size: cover;
  background-position: center;
}

.category-image.men {
  background-image: url('https://images.unsplash.com/photo-1516257984-b1b4d707412e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80');
}

.category-image.women {
  background-image: url('https://images.unsplash.com/photo-1483985988355-763728e1935b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80');
}

.category-card h3 {
  padding: 20px 20px 10px;
  font-size: 22px;
}

.category-card p {
  padding: 0 20px 20px;
  color: #666;
}

/* Featured Products Section */
.featured-products {
  background-color: white;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.view-all-button {
  text-align: center;
  margin-top: 40px;
}

/* Why Choose Us Section */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.feature {
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.feature:hover {
  transform: translateY(-10px);
}

.feature i {
  font-size: 36px;
  color: #4CAF50;
  margin-bottom: 20px;
}

.feature h3 {
  font-size: 20px;
  margin-bottom: 15px;
}

.feature p {
  color: #666;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 32px;
  }

  .hero-buttons {
    flex-direction: column;
  }

  .hero-buttons .btn {
    margin-bottom: 10px;
  }
}
</style>
